import {
    ref,
    toRefs
} from 'vue';
import request from '@/request'

/**
 * 获取字典数据
 */
export function getDict(...args) {
    const res = ref({});
    return (() => {
        args.forEach((d, index) => {
            res.value[d] = [];
            getDictDropdown(d).then(result => {
                // console.log(result, Object.keys(result), '======result');

                const resData = []
                Object.keys(result).forEach(key => {
                    // const result = {}
                    if (result[key]) {
                        resData.push({
                            label: result[key],
                            value: key
                        })
                    }
                })
                res.value[d] = resData
            })
        })
        return toRefs(res.value);
    })()
}

async function getDictDropdown(type, sort = 'asc') {
    return request
        .get(`/api/sys/v1/sys/dicts/types/${type}/dropdown?sort=${sort}`)
        .then((response) => response.data)
}